/* eslint-disable jsx-a11y/anchor-is-valid */
import {Button} from '@mui/material'
import {FC, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {KTSVG} from '../../../helpers'
import * as filter from '../../../../app/redux-commons/FilterRedux/filterRedux'
import {AllMessages, useLocalStorage} from '../../../../app/utils'
import SearchIcon from '@mui/icons-material/Search'
import {
  AutoCompleteBasCasMultiple,
  InputBanCas,
} from '../../../../app/modules/Bancassurance/components'
import {CustomModal} from '../../modals/CustomModal'
import {FormChooseCustomer} from '../../../../app/pages/dashboard/components/FormChooseCustomer'
import { Lang } from '../../../../app/modules/auth/apis'

const DrawerDashboard: FC = () => {
  const [openModal, setOpenModal] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const [listPartner, setListPartner] = useState<any>([])
  const [listDivision, setListDivision] = useState<any>([])
  const [division] = useLocalStorage<any[]>('view:division', [])
  const [partner] = useLocalStorage<any[]>('view:partner', [])
  const [lang] = useLocalStorage<Lang>('i18nConfig', {selectedLang: 'vi'})
  const filterState = useSelector((state: RootState) => state.filter).FilterDashboard
  const dispatch = useDispatch()

  const handleOpenModalCustomer = () => {
    setModalTitle('Khách hàng')
    setOpenModal(true)
  }

  const handleFilter = () => {
    dispatch(filter.actions.updateApplyFilterStatus(true))
  }

  const handleClearFilter = () => {
    dispatch(filter.actions.cleanFilterInfo('FilterDashboard'))
  }

  const handleGetCustomerSelected = (data: string[]) => {
    setOpenModal(false)
    dispatch(
      filter.actions.updateFilterInfo({
        field: 'customer',
        value: data.toString(),
        filterForm: 'FilterDashboard',
      })
    )
  }

  useEffect(() => {
    setListPartner(() => {
      let arr: any = []
      partner.forEach((elem) => {
        let obj = {
          label: elem.label,
          value: elem.value
        }
        arr.push(obj)
      })
      return arr
    })
    setListDivision(() => {
      let arr: any = []
      division.forEach((elem) => {
        let obj = {
          label: elem.label,
          value: elem.value
        }
        arr.push(obj)
      })
      return arr
    })
  },[])

  return (
    <>
      <div
        id='kt_drawer_filter_dashboard'
        className='bg-white'
        data-kt-drawer='true'
        data-kt-drawer-name='filter_dashboard'
        data-kt-drawer-activate='true'
        data-kt-drawer-overlay='true'
        data-kt-drawer-width="{default:'350px', 'md': '350px'}"
        data-kt-drawer-direction='end'
        data-kt-drawer-toggle='#kt_drawer_filter_dashboard_toggle'
        data-kt-drawer-close='#kt_drawer_filter_dashboard_close'
      >
        <div className='card w-100 rounded-0' id='kt_drawer_filter_dashboard_wrap'>
          <div
            className='card-header pe-5'
            id='kt_drawer_filter_dashboard_header'
            style={{backgroundColor: 'inherit'}}
          >
            <div className='card-title'>
              <div className='d-flex justify-content-center flex-column me-3'>
                <div className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1'>
                {AllMessages[lang.selectedLang].DASHBOARD_BO_LOC}
                </div>
              </div>
            </div>
            <div className='card-toolbar'>
              <div
                className='btn btn-sm btn-icon btn-active-light-primary'
                id='kt_drawer_chat_close'
              >
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
              </div>
            </div>
          </div>
          <div className='card-body'>
            <div className='row'>
              <div className='col-12'>
                <AutoCompleteBasCasMultiple
                  id='exploitingCode'
                  options={listPartner}
                  label={AllMessages[lang.selectedLang].DAI_LY}
                  defaultValue={filterState.exploitingCode}
                  formName='FilterDashboard'
                />
              </div>
              <div className='col-12'>
                <AutoCompleteBasCasMultiple
                  id='division'
                  options={listDivision}
                  label={AllMessages[lang.selectedLang].CHI_NHANH}
                  defaultValue={filterState.division}
                  formName='FilterDashboard'
                />
              </div>
              <div className='col-12' style={{position: 'relative'}}>
                <InputBanCas
                  label={AllMessages[lang.selectedLang].KHACH_HANG}
                  placehoder={AllMessages[lang.selectedLang].CHON_KHACH_HANG}
                  id='customerDashboard'
                  name='Khách hàng'
                  inputReadonly
                  inputValue={filterState.customer}
                />
                <Button
                  size='small'
                  variant='contained'
                  sx={{position: 'absolute', top: '22px', right: '15px'}}
                  onClick={handleOpenModalCustomer}
                >
                  <SearchIcon fontSize='small' />
                </Button>
              </div>
            </div>
          </div>
          <div className='card-footer'>
            <div>
              <Button
                variant='contained'
                fullWidth
                size='medium'
                className='modal-footer-btn'
                sx={{marginTop: '7px', marginBottom: '7px'}}
                onClick={handleFilter}
              >
                Tìm kiếm
              </Button>
            </div>
            <div>
              <Button
                variant='outlined'
                size='medium'
                fullWidth
                className='modal-footer-btn'
                sx={{marginBottom: '7px'}}
                onClick={handleClearFilter}
              >
                Làm mới bộ lọc
              </Button>
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        open={openModal}
        handleCloseModal={(close) => setOpenModal(close)}
        widthModal='80%'
        modalTitle={modalTitle}
        ModalBtn={() => <></>}
      >
        {modalTitle == 'Khách hàng' && (
          <FormChooseCustomer
            customerSelected={filterState.customer ? filterState.customer.split(',') : []}
            handleCustomerSelected={handleGetCustomerSelected}
          />
        )}
      </CustomModal>
    </>
  )
}

export {DrawerDashboard}
